// src/features/alerts/alertThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setAlertData } from "./alertSlice";
export const fetchAlertConfigDetails = createAsyncThunk(
  "alerts/fetchAlertConfigDetails",
  async (alertID, { rejectWithValue, dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        "https://v3.dhundhoo.com/alerts/getAlertConfigDetails",
        {
          method: "POST", // API initializes with POST
          headers: {
            "x-dhundhoo-session": token,
          },
          body: JSON.stringify({ alertID }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch alert config details");
      }

      const data = await response.json();
      console.log(data.responseData, "response data ");
      dispatch(setAlertData(data.responseData))
      // return only the needed response data
      return data.responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
